import { DateTime } from 'luxon';


/**
 * @description Returns a boolean indicating whether the date is within the last 24 hours
 * @param date - the date to check in format "DD MM HH:MM:SS UTC YYYY"
 * @returns boolean - true if the date is within the last 24 hours
 */
export const withinLast24Hours = (date: string): boolean => {
  const now = DateTime.utc();
  const targetDate = DateTime.fromFormat(date, 'MM dd HH:mm:ss z yyyy', { zone: 'UTC' });

  const diffInHours = now.diff(targetDate, 'hours').hours;
  return diffInHours >= 0 && diffInHours <= 24;
};
